import React from 'react';
import { AptitudeTest } from '../Components';

const AptitudeTestDemo: React.FC = () => {
  return <AptitudeTest />;
};

export default AptitudeTestDemo;
